export const update = (data) => ({
  type: "INSURANCE_PRODUCT/UPDATE",
  payload: data,
});

export const clear = () => ({
  type: "INSURANCE_PRODUCT/CLEAR",
  payload: {},
});
